import { TenantEntity } from '../TenantEntity'

export class FlightScheduleItem extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FlightScheduleItem'
  }
  get itemName() {
    return this._data.itemName
  }
  set itemName(itemName) {
    this._data.itemName = itemName
  }
  get departureTime() {
    return this._data.departureTime
  }
  set departureTime(departureTime) {
    this._data.departureTime = departureTime
  }
  get flyingDays() {
    return this._data.flyingDays
  }
  set flyingDays(flyingDays) {
    this._data.flyingDays = flyingDays || 0
  }
  get arrivalTime() {
    return this._data.arrivalTime
  }
  set arrivalTime(arrivalTime) {
    this._data.arrivalTime = arrivalTime
  }
  get airTransitRoutingDescriptionUuid() {
    return this._data.airTransitRoutingDescriptionUuid
  }
  set airTransitRoutingDescriptionUuid(airTransitRoutingDescriptionUuid) {
    this._data.airTransitRoutingDescriptionUuid = airTransitRoutingDescriptionUuid
  }
  get flightDescriptionUuid() {
    return this._data.flightDescriptionUuid
  }
  set flightDescriptionUuid(flightDescriptionUuid) {
    this._data.flightDescriptionUuid = flightDescriptionUuid
  }
}
